export default "__VITE_ASSET__CZ8xHZe9__"